import { useEffect } from 'react';
import { X } from 'lucide-react';
import './PdfViewer.css';

export default function PdfViewer({ pdfUrl, title, onClose }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="pdf-viewer">
      <div className="pdf-viewer-header">
        <h3 className="pdf-viewer-title">{title}</h3>
        <button onClick={onClose} className="pdf-viewer-close">
          <X size={24} />
        </button>
      </div>
      <div className="pdf-viewer-content">
        <iframe src={pdfUrl} className="pdf-viewer-iframe" title={title} />
      </div>
    </div>
  );
}